<template>
  <div>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='wms wms-purchaseorder' class='navbarbtn' v-if='showCreateDeliveryBillPower'
        @click='showCreateDeliveryBillDialogMD'>
        生成送货单
      </el-button>

      <el-button type='primary' icon='wms wms-purchaseorder' class='navbarbtn' v-if='showBatchCreateDeliveryBillPower'
        @click='showBatchCreateDeliveryBillDialogMD'>
        批量生成送货单
      </el-button>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true' operationColumnWidth='90px'
      :expandRowKeys='mainTable.expandRowKeys'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='操作日志' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showPOOrderLogDialogMD(scope)'><i class='sys sys-log'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='送货单明细' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showPODeliveryBillDialogMD(scope)'><i class='wms wms-purchaseorder'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>含税单价</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>价税合计</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>税率</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 110px; text-align: left;'><span style='color: #42426F;'>交期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 110px; text-align: left;'><span style='color: #42426F;'>回复交期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>生成送货单</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>生成标签</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>到货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>入库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>退货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='ppoe in scope.data.row.detailDt1' :style='mainTableDetail1RowStyle(scope.data.row, ppoe)'
            :key='ppoe.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{ppoe.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.Qty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.AuxTaxPrice}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{typeof (ppoe.AllAmount) === 'number' ? ppoe.AllAmount.toFixed(2) : ''}} </span></div>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{ppoe.Cess}}% </span></div>
            <div class='expand-row' style='min-width: 110px; text-align: left;'><span style='color: blue;'>{{ppoe.DevDate.substring(0, 10)}} </span></div>
            <div class='expand-row' style='min-width: 110px; text-align: left;'><span style='color: blue;'>{{ppoe.NewDevDate ? ppoe.NewDevDate.substring(0, 10) : ''}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppoe.CreateDeliveryBillQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppoe.CreateQRCodeQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.CommitQty + ppoe.ReturnQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.StockQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.ReturnQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemModel}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog v-dialogDrag title='操作日志' :visible.sync='showPOOrderLogDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='POOrderLog' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='LogNo' label='记录号' width='160'>
        </el-table-column>
        <el-table-column prop='Content' label='操作内容' width='500'>
        </el-table-column>
        <el-table-column prop='CreateTime' label='操作时间' width='160'>
          <template #default='scope'>
            {{dateTimeUtil.formartDateTime(new Date(scope.row.CreateTime), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog v-dialogDrag title='送货单明细' :visible.sync='showPODeliveryBillDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='poDeliveryBills' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;' default-expand-all>
        <el-table-column type='expand' width='50'>
          <template #default='scope'>
            <div class='expand'>
              <div class='expand-inner'>
                <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>生成标签</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>到货</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>入库</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>退货</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>红字</span></div>
              </div>
            </div>
            <div class='expand'>
              <div v-for='pdbe in scope.row.detailDt1'
                :key='pdbe.EntryID' class='expand-inner'>
                <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'>{{pdbe.EntryID}} </span></div>
                <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: #42426F;'>{{pdbe.ItemNumber}} </span></div>
                <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: #42426F;'>{{pdbe.ItemName}} </span></div>
                <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: #42426F;'>{{pdbe.ItemModel}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{pdbe.Qty}}{{pdbe.UnitName}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{pdbe.CreateQRCodeQty}}{{pdbe.UnitName}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{pdbe.CommitQty}}{{pdbe.UnitName}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{pdbe.StockQty}}{{pdbe.UnitName}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{pdbe.ReturnQty}}{{pdbe.UnitName}} </span></div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{pdbe.RedQty}}{{pdbe.UnitName}} </span></div>
                </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='BillNo' label='采购单号' width='160'>
        </el-table-column>
        <el-table-column prop='DeliveryBillNo' label='送货单号' width='160'>
        </el-table-column>
        <el-table-column prop='DeliveryDate' label='送货日期' width='100'>
        </el-table-column>
        <el-table-column prop='SYSAutoCreateFlag' label='是否系统自动生成' width='150'>
          <template #default='scope'>
            {{scope.row.SYSAutoCreateFlag === '1' ? '是' : '否'}}
          </template>
        </el-table-column>
        <el-table-column prop='Remark' label='备注' width='1000'>
        </el-table-column>
        <el-table-column prop='CreateTime' label='创建时间' width='160'>
        </el-table-column>
        <el-table-column prop='CreateUserCode' label='创建人' width='100'>
        </el-table-column>
        <el-table-column label='操作' width='90' fixed='right'>
          <template #default='scope'>
            <el-button type='primary' circle style='padding: 4px;' v-if='scope.row.SYSAutoCreateFlag === "1" && showCreateDeliveryBillPower'
              @click='showEditDeliveryBillDiaologMD(scope)'><i class='sys sys-edit'></i>
            </el-button>
            <el-button type='danger' circle style='padding: 4px;' v-if='showDeleteDeliveryBillPower'
              @click='deleteDeliveryBill(scope)'><i class='sys sys-delete'></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title='editPODeliveryBill.BillNo + "修改送货单"' :visible.sync='showEditDeliveryBillDiaolog' append-to-body
        top='10px' lock-scroll width='1000px'>
        <el-table :data='poDeliveryBillEntrys' border height='300px'
          :cell-style='mainTableCellStyle' style='margin-top: -30px;' row-key='GUID'
          :header-cell-style='mainTableHeaderCellStyle' size='medium'>
          <el-table-column prop='EntryID' label='行号' width='60'>
          </el-table-column>
          <el-table-column prop='ItemNumber' label='物料代码' width='350'>
          </el-table-column>
          <el-table-column prop='ItemName' label='物料名称' width='300'>
          </el-table-column>
          <el-table-column prop='ItemModel' label='物料规格' width='300'>
          </el-table-column>
          <el-table-column prop='Qty' label='送货数量' width='80'>
          </el-table-column>
          <el-table-column prop='CommitQty' label='到货数量' width='80'>
          </el-table-column>
          <el-table-column prop='NewQty' label='修改后送货数量' width='150'>
            <template #header>
              <span style='color: blue;'>修改后数量</span>
            </template>
            <template #default='scope'>
              <input class='tableInput' v-model='scope.row.NewQty'
                style='width: 130px;'/>
            </template>
          </el-table-column>
          <el-table-column prop='UnitName' label='单位' width='60'>
          </el-table-column>
          <el-table-column prop='SupplyName' label='供应商' width='250'>
          </el-table-column>
        </el-table>
        <div class='dialogButtomCenterBtn'>
          <el-button type='primary' @click='editPODeliveryBillMD()' size='mini'>修改</el-button>
          <el-button @click='showEditDeliveryBillDiaolog = false' size='mini'>取消</el-button>
        </div>
      </el-dialog>
    </el-dialog>

    <el-dialog :title='deliveryBillPOOrder.BillNo + "生成送货单"' :visible.sync='showCreateDeliveryBillDialog' fullscreen
      top='10px' lock-scroll>
      <div style='margin-top: -30px;'>
        <el-button class='inputField-input'
          type='primary' @click='autoCompleteDeliveryQty()' size='mini'>自动填充发货数量</el-button>
        <el-button class='inputField-input'
          type='primary' @click='clearDeliveryQty()' size='mini'>清除发货数量</el-button>
        <div class='inputField-label' style='width: 65px; text-align: left'>
          送货日期
        </div>
        <el-date-picker class='inputField-input' v-model='deliveryBill.deliveryDate'
          value-format='yyyy-MM-dd' size='mini' style='width: 160px;'>
        </el-date-picker>
        <div class='inputField-label' style='width: 35px; text-align: left'>
          备注
        </div>
        <el-input class='inputField-input' v-model='deliveryBill.remark'
          size='mini' style='width: 380px;'>
        </el-input>
      </div>
      <el-table :data='deliveryBillRows' border :height='getCreateDeliveryBillHeight()'
        ref='createDeliveryBillTable'
        :cell-style='mainTableCellStyle' style='margin-top: 40px;' row-key='GUID'
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column prop='EntryID' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='350'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='300'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='物料规格' width='300'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='80'>
        </el-table-column>
        <el-table-column prop='CreateDeliveryBillQty' label='已生成送货单数量' width='140'>
        </el-table-column>
        <el-table-column prop='ThisCreateDeliveryBillQty' label='本次生成送货单数量' width='150'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisCreateDeliveryBillQty'
              style='width: 130px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='DevDate' label='交期' width='100'>
          <template #default='scope'>
            <span>{{scope.row.DevDate.substring(0, 10)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop='SupplyName' label='供应商' width='250'>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='createDeliveryBill()' size='mini'>生成送货单</el-button>
        <el-button @click='showCreateDeliveryBillDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title='批量生成送货单' :visible.sync='showBatchCreateDeliveryBillDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <el-button class='inputField-input'
          type='primary' @click='autoCompleteBatchDeliveryQty()' size='mini'>自动填充发货数量</el-button>
        <el-button class='inputField-input'
          type='primary' @click='clearBatchDeliveryQty()' size='mini'>清除发货数量</el-button>
        <div class='inputField-label' style='width: 65px; text-align: left'>
          送货日期
        </div>
        <el-date-picker class='inputField-input' v-model='batchDeliveryBill.deliveryDate'
          value-format='yyyy-MM-dd' size='mini' style='width: 160px;'>
        </el-date-picker>
        <div class='inputField-label' style='width: 35px; text-align: left'>
          备注
        </div>
        <el-input class='inputField-input' v-model='batchDeliveryBill.remark'
          size='mini' style='width: 380px;'>
        </el-input>
      </div>
      <el-table :data='batchDeliveryBillRows' border :height='getBatchCreateDeliveryBillHeight()'
        ref='batchCreateDeliveryBillTable'
        :cell-style='mainTableCellStyle' style='margin-top: 40px;' row-key='GUID'
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column prop='BillNo' label='采购订单号' width='160'>
        </el-table-column>
        <el-table-column prop='EntryID' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='350'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='300'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='物料规格' width='300'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='80'>
        </el-table-column>
        <el-table-column prop='CreateDeliveryBillQty' label='已生成送货单数量' width='140'>
        </el-table-column>
        <el-table-column prop='ThisCreateDeliveryBillQty' label='本次生成送货单数量' width='150'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisCreateDeliveryBillQty'
              style='width: 130px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='DevDate' label='交期' width='100'>
          <template #default='scope'>
            <span>{{scope.row.DevDate.substring(0, 10)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop='SupplyName' label='供应商' width='250'>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='batchCreateDeliveryBill()' size='mini'>生成送货单</el-button>
        <el-button @click='showBatchCreateDeliveryBillDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'CreateDeliveryBill',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'PO_POOrder_4',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        customFilterStr: ' AND 1=0 ',
        Loading: false,

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      dateTimeUtil: dateTimeUtil,

      showPOOrderLogDialog: false,
      POOrderLog: [],

      showCreateDeliveryBillDialog: false,
      deliveryBillPOOrder: {},
      deliveryBillRows: [],
      deliveryBill: {
        deliveryDate: '',
        deliveryName: '',
        remark: ''
      },

      showBatchCreateDeliveryBillDialog: false,
      batchDeliveryBillPOOrders: [],
      batchDeliveryBillRows: [],
      batchDeliveryBill: {
        deliveryDate: '',
        deliveryName: '',
        remark: ''
      },

      showPODeliveryBillDialog: false,
      poDeliveryBills: [],

      showEditDeliveryBillDiaolog: false,
      editPODeliveryBill: {},
      poDeliveryBillEntrys: [],

      showCreateDeliveryBillPower: false,
      showBatchCreateDeliveryBillPower: false,
      showDeleteDeliveryBillPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)

    const rtnObjPromise = axiosHelper.handle('/WebAction/BaseData.User.GetUserSupply', {
    })
    const rtnObj = await rtnObjPromise
    if (rtnObj && rtnObj.error === '000000') {
      if (rtnObj.supplyRoleFlag === '0' && rtnObj.purchaseManagerRoleFlag === '0') {
        that.mainTable.customFilterStr = ''
      } else {
        let customFilterStr = " AND SupplyID IN (''"
        for (let i = 0; i < rtnObj.supplys.length; i++) {
          customFilterStr += ",'" + rtnObj.supplys[i].SupplyID + "'"
        }
        customFilterStr += ')'
        that.mainTable.customFilterStr = customFilterStr
      }
    }

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.mainTable.detail1FilterStr = ''
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Closed === '1' || data.row.Cancellation === 'True') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '3') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '2' || data.row.Status === '1') {
        if (data.row.CreateDeliveryStatues === '2') {
          return { 'background-color': '#cccccc' }
        } else if (data.row.DocumentCheckStatus === '1') {
          return { 'background-color': '#00FF7F' }
        } if (data.row.DocumentCommitStatus === '2') {
          return { 'background-color': '#FF4500' }
        } else if (data.row.DocumentCommitStatus === '1') {
          return { 'background-color': '#99ffff' }
        } else if (data.row.UploadDocumentStatus === '1') {
          return { 'background-color': 'orange' }
        }
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 展开行行样式设定方法
    mainTableDetail1RowStyle: function (row, ppoe) {
      if (row.Closed === '1' || row.Cancellation === 'True') {
        return { 'background-color': '#aaaaaa' }
      } else if (row.Status === '3' || ppoe.ErpClosed === '1') {
        return { 'background-color': '#cccccc' }
      } else if (row.CanCreateDeliveryBillQty <= 0) {
        return { 'background-color': '#cccccc' }
      }
    },

    // 显示采购相关日志
    showPOOrderLogDialogMD: async function (scope) {
      const that = this
      that.POOrderLog = scope.data.row.detailDt3
      that.showPOOrderLogDialog = true
    },

    // 获取条码弹出框表格高度
    getCreateDeliveryBillHeight: function () {
      return window.innerHeight - 170 + 'px'
    },

    // 获取条码弹出框表格高度
    getBatchCreateDeliveryBillHeight: function () {
      return window.innerHeight - 170 + 'px'
    },

    // 表格单元格样式
    mainTableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    mainTableHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      if (column.property && (column.property === 'ThisCreateDeliveryBillQty')) {
        return { color: 'blue', padding: '5px', 'background-color': '#f5f7fa' }
      } else {
        return { padding: '5px', 'background-color': '#f5f7fa' }
      }
    },

    // 显示新增送货单弹出框
    showCreateDeliveryBillDialogMD: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      if (that.mainTable.selections.length > 1) {
        that.$message.error('请选择单条数据！')
        return
      }

      if (that.mainTable.selections[0].CreateDeliveryStatues === '2') {
        that.$message.error('请选择未完全生成送货单的数据！')
        return
      }
      that.mainTable.selections[0].detailDt1.forEach(selectionDetailDt1 => {
        selectionDetailDt1.ThisCreateDeliveryBillQty = 0
      })
      that.deliveryBillPOOrder = that.mainTable.selections[0]
      that.deliveryBillRows = that.mainTable.selections[0].detailDt1
      that.deliveryBill.deliveryDate = dateTimeUtil.formartDateTime(new Date(), 'yyyy-MM-dd')
      that.deliveryBill.deliveryName = ''
      that.deliveryBill.remark = ''
      that.showCreateDeliveryBillDialog = true
    },

    // 自动填充发货数量方法
    autoCompleteDeliveryQty: function () {
      const that = this
      for (let i = 0; i < that.deliveryBillRows.length; i++) {
        that.deliveryBillRows[i].ThisCreateDeliveryBillQty = that.deliveryBillRows[i].Qty + that.deliveryBillRows[i].ReturnQty - that.deliveryBillRows[i].CreateDeliveryBillQty
      }
      that.$refs.createDeliveryBillTable.doLayout()
    },

    // 清除发货数量方法
    clearDeliveryQty: function () {
      const that = this
      for (let i = 0; i < that.deliveryBillRows.length; i++) {
        that.deliveryBillRows[i].ThisCreateDeliveryBillQty = 0
      }
      that.$refs.createDeliveryBillTable.doLayout()
    },

    // 生成送货单
    createDeliveryBill: async function () {
      const that = this
      if (!that.deliveryBill.deliveryDate) {
        that.$message.error('请输入送货日期！')
        return
      }
      if (dateTimeUtil.formartDateTime(new Date(), 'yyyy-MM-dd') > that.deliveryBill.deliveryDate) {
        that.$message.error('送货日期不能小于当天！')
        return
      }
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      let allQty = 0
      for (let i = 0; i < that.deliveryBillRows.length; i++) {
        if (that.deliveryBillRows[i].ThisCreateDeliveryBillQty === '') {
          that.$message.error('请输入本次生成送货单数量！')
          return
        }
        if (!numberReg.test(that.deliveryBillRows[i].ThisCreateDeliveryBillQty)) {
          that.$message.error('本次生成送货单数量必须为数字！')
          return
        }
        if (parseFloat(that.deliveryBillRows[i].ThisCreateDeliveryBillQty) < 0) {
          that.$message.error('本次生成送货单数量必须大于等于0！')
          return
        }
        allQty += parseFloat(that.deliveryBillRows[i].ThisCreateDeliveryBillQty)
      }
      if (allQty <= 0) {
        that.$message.error('本次生成送货单数量必须有一行大于0！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.CreateDeliveryBill', {
        porder: that.deliveryBillPOOrder,
        deliveryBill: that.deliveryBill,
        deliveryBillEntry: that.deliveryBillRows
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showCreateDeliveryBillDialog = false
        that.$message.success('生成送货单成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 送货单显示方法
    showPODeliveryBillDialogMD: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const poDeliveryBillsObj = await table.getTableContent('PO_DeliveryBill'
        , 10000, 1, ' DeliveryBillNo ASC', " AND POInterID='" + scope.data.row.InterID + "'")
      if (poDeliveryBillsObj.error === '000000') {
        that.poDeliveryBills = poDeliveryBillsObj.tableContent
        that.deliveryBillPOOrder = scope.data.row
        that.showPODeliveryBillDialog = true
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 送货单删除方法
    deleteDeliveryBill: function (scope) {
      const that = this
      that.$confirm('确定要删除该送货单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.DeleteDeliveryBill', {
          deliveryBill: scope.row
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除该送货单成功！')
          that.showPODeliveryBillDialogMD({ data: { row: that.deliveryBillPOOrder } })
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 显示批量新增送货单弹出框
    showBatchCreateDeliveryBillDialogMD: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }

      that.batchDeliveryBillRows = []
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].CreateDeliveryStatues === '2') {
          that.$message.error('采购订单【' + that.mainTable.selections[i].BillNo + '】已完全生成送货单！请选择未完全生成送货单的数据！')
          return
        }
        that.mainTable.selections[i].detailDt1.forEach(selectionDetailDt1 => {
          selectionDetailDt1.ThisCreateDeliveryBillQty = 0
          that.batchDeliveryBillRows.push(selectionDetailDt1)
        })
      }

      that.batchDeliveryBillPOOrders = that.mainTable.selections
      that.batchDeliveryBill.deliveryDate = dateTimeUtil.formartDateTime(new Date(), 'yyyy-MM-dd')
      that.batchDeliveryBill.deliveryName = ''
      that.batchDeliveryBill.remark = ''
      that.showBatchCreateDeliveryBillDialog = true
    },

    // 自动填充发货数量方法
    autoCompleteBatchDeliveryQty: function () {
      const that = this
      for (let i = 0; i < that.batchDeliveryBillRows.length; i++) {
        that.batchDeliveryBillRows[i].ThisCreateDeliveryBillQty = that.batchDeliveryBillRows[i].Qty + that.batchDeliveryBillRows[i].ReturnQty - that.batchDeliveryBillRows[i].CreateDeliveryBillQty
      }
      that.$refs.batchCreateDeliveryBillTable.doLayout()
    },

    // 清除发货数量方法
    clearBatchDeliveryQty: function () {
      const that = this
      for (let i = 0; i < that.batchDeliveryBillRows.length; i++) {
        that.batchDeliveryBillRows[i].ThisCreateDeliveryBillQty = 0
      }
      that.$refs.batchCreateDeliveryBillTable.doLayout()
    },

    // 批量生成送货单
    batchCreateDeliveryBill: async function () {
      const that = this
      if (!that.batchDeliveryBill.deliveryDate) {
        that.$message.error('请输入送货日期！')
        return
      }
      if (dateTimeUtil.formartDateTime(new Date(), 'yyyy-MM-dd') > that.batchDeliveryBill.deliveryDate) {
        that.$message.error('送货日期不能小于当天！')
        return
      }
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      let allQty = 0
      for (let i = 0; i < that.batchDeliveryBillRows.length; i++) {
        if (that.batchDeliveryBillRows[i].ThisCreateDeliveryBillQty === '') {
          that.$message.error('请输入本次生成送货单数量！')
          return
        }
        if (!numberReg.test(that.batchDeliveryBillRows[i].ThisCreateDeliveryBillQty)) {
          that.$message.error('本次生成送货单数量必须为数字！')
          return
        }
        if (parseFloat(that.batchDeliveryBillRows[i].ThisCreateDeliveryBillQty) < 0) {
          that.$message.error('本次生成送货单数量必须大于等于0！')
          return
        }
        allQty += parseFloat(that.batchDeliveryBillRows[i].ThisCreateDeliveryBillQty)
      }
      if (allQty <= 0) {
        that.$message.error('本次生成送货单数量必须有一行大于0！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.BatchCreateDeliveryBill', {
        porders: that.batchDeliveryBillPOOrders,
        batchDeliveryBill: that.batchDeliveryBill,
        batchDeliveryBillEntry: that.batchDeliveryBillRows
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showBatchCreateDeliveryBillDialog = false
        that.$message.success('批量生成送货单成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 修改送货单弹出框显示方法
    showEditDeliveryBillDiaologMD: async function (scope) {
      const that = this
      that.poDeliveryBillEntrys = []
      for (let i = 0; i < scope.row.detailDt1.length; i++) {
        that.poDeliveryBillEntrys.push(Object.assign({
          NewQty: scope.row.detailDt1[i].Qty
        }, scope.row.detailDt1[i]))
      }
      that.editPODeliveryBill = scope.row
      that.showEditDeliveryBillDiaolog = true
    },

    // 修改送货单
    editPODeliveryBillMD: async function () {
      const that = this
      let allQty = 0
      for (let i = 0; i < that.poDeliveryBillEntrys.length; i++) {
        if (that.poDeliveryBillEntrys[i].NewQty < that.poDeliveryBillEntrys[i].CommitQty) {
          that.$message.error('修改后送货数量不能小于已到货数量！')
          return
        }
        allQty += that.poDeliveryBillEntrys[i].NewQty
      }
      if (allQty <= 0) {
        that.$message.error('修改后送货数量不能全为0！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.EditPODeliveryBill', {
        poDeliveryBillEntrys: that.poDeliveryBillEntrys,
        poDeliveryBill: that.editPODeliveryBill
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showEditDeliveryBillDiaolog = false
        that.showPODeliveryBillDialog = false
        that.$message.success('修改送货单成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.tableInput {
  height: 26px;
  line-height: 26px;
  border: 0px #FFFFFF;
  background-color: transparent;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
